import React from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Certificate from "./components/Certificate";

export default function App() {
  return (
    <main className="text-gray-400 bg-gray-900 body-font"> 
      <Navbar />
      <About />
      <Projects />
      <Skills />
      <Certificate />
      <Contact />
    </main>
  );
}


// WEBPACK FOOTER //
// ./src/App.js